<app-centre-small-opener>
    <h2 mat-dialog-title dialogTitle class="mar-b-5 pd-t-5px">Add Link</h2>
    <mat-icon (click)="closeDialog()" mat-dialog-close>
      close
    </mat-icon>
    <div contentContainer class="row">
      <div class="">
        <div class="">
          <!-- <div class="col-lg-2 col-sm-2 align-self-center">
            <label><h4 class="label-content">Enter Link:</h4></label>
          </div> -->
          <form [formGroup]="addLinkBox" class = "row d-flex">
            <div class="col-md-8 justify-content-start">            
              <!-- <input class="col-lg-12" type="url" name = "file" id = "file_drive"/> -->
              <mat-form-field class="col-lg-12 col-12">
                <mat-label class="body-font-size">Enter URL</mat-label>
                <input id = "special" class="body-font-size" matInput placeholder="" formControlName="attachmentLink">
                <mat-error *ngIf = "validate && addLinkBox.hasError('pattern', 'attachmentLink')" [ngStyle]="{'color':'red'}">*Invalid URL</mat-error>
                <mat-error *ngIf = "validate && addLinkBox.hasError('required', 'attachmentLink')" [ngStyle]="{'color':'red'}">*Field empty</mat-error>
              </mat-form-field>
              <!-- <mat-error *ngIf = "validate && addLinkBox.hasError('pattern', 'attachmentLink')" [ngStyle]="{'color':'red'}">*Invalid URL</mat-error>
              <mat-error *ngIf = "validate && addLinkBox.hasError('required', 'attachmentLink')" [ngStyle]="{'color':'red'}">*Field empty</mat-error> -->
            </div>
            <div class="col-md-4 justify-content-end text-end" [ngStyle]="{'padding':'0px 10px 10px 0px'}">
              <button [disabled] = "!attachmentData.data" mat-raised-button actions class="button-container mar-l-8 primary" (click)="saveAttachmentLink()" [disabled] = "disableAttachmentFileIcon">
                SAVE
              </button>
              <button [disabled] = "!attachmentData.data" mat-raised-button type = "button" (click) = "reset()" actions class="button-container mar-l-8 primary">
                RESET
              </button>
            </div>  
          </form>
          
          <!-- <div class="col-lg-2 col-sm-12" [ngStyle]="{'text-align':'center'}">
            
          </div> -->
        </div>
      </div>
    </div>

    <div contentContainer class="row example-accordion-item-body">
      <table mat-table [dataSource]="linkDataSource" class="col-12 mat-elevation-z2 demo-table" matSort>
             
        <!-- file name Column -->
        <ng-container matColumnDef="linkURL">
          <th mat-header-cell class="header-container" *matHeaderCellDef> Link URL </th>
          <td mat-cell *matCellDef="let attachment" [ngStyle]="{'cursor':'pointer'}" class="col-lg-8 outline-r removeBorder" contenteditable="false" (blur) = "attachmentData.data ? removeContentEditable(attachment.attachmentId) : ''" mat-cell id = {{attachment.attachmentId}}> <span [ngStyle]="{'font-size':'0.9rem'}" id="attachlink{{attachment.attachmentId}}"><a href="{{attachment.attachmentLink}}" target="_blank"> {{attachment.attachmentLink}}</a></span> </td>
        </ng-container>
        <ng-container matColumnDef="edit">
          <th mat-header-cell class="header-container" *matHeaderCellDef> Edit </th>
          <td mat-cell *matCellDef="let attachment" class="col-lg-2 body-font-size removeBorder"><button mat-icon-button (click)="attachmentData.data ? triggerContentEditable(attachment.attachmentId) : ''" class="icon-bttn"><mat-icon class="icon-logo"> edit </mat-icon></button></td>
        </ng-container>
      

        <!-- delete Column -->
        <ng-container matColumnDef="delete">
          <th mat-header-cell class="header-container" *matHeaderCellDef> Delete </th>
          <td mat-cell *matCellDef="let attachment" class="col-lg-2 body-font-size removeBorder"><button mat-icon-button (click)="attachmentData.data ? deleteAttachment(attachment.attachmentId) : ''" class="icon-bttn" [disabled] = "disableAttachmentFileIcon"><mat-icon class="icon-logo" > delete </mat-icon></button></td>
        </ng-container>
      
        <!-- edit Column -->
        <!-- <ng-container matColumnDef="edit">
          <th mat-header-cell class="header-container" *matHeaderCellDef> Edit </th>
          <td mat-cell *matCellDef="let element"><button mat-icon-button class="icon-bttn"><mat-icon class="icon-logo"> {{element.edit}} </mat-icon></button></td>
        </ng-container> -->

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr [ngClass] = "row.existing ? 'left-border' : '' " mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
    <div actions>
      <mat-paginator  [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of users"></mat-paginator>
    </div>

     
      
  </app-centre-small-opener>